import React from "react";
import { Box, SpaceBetween } from "@amzn/awsui-components-react/polaris";
import Button from "@amzn/awsui-components-console/button";

/**
 * Component to render clickable suggestion items that auto-inject text and submit queries
 */
const ClickableSuggestions = ({ suggestions, onSuggestionClick }) => (
    <Box>
        <Box marginBottom="m">Welcome to Lighthouse chat! I can help with actions such as:</Box>
        <SpaceBetween size="xs">
            {suggestions.map(suggestion => (
                <Box display="flex" alignItems="flex-start">
                    <span>•&nbsp;</span>
                    <Button
                        variant="inline-link"
                        onClick={() => onSuggestionClick(suggestion.text)}
                    >
                        {suggestion.text}
                    </Button>
                </Box>
            ))}
        </SpaceBetween>
    </Box>
);

export default ClickableSuggestions;
